/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rust_Happy_Rat_MendInputs */

const en_rust_happy_rat_mend = /** @type {(inputs: Rust_Happy_Rat_MendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In progress`)
};

const de_rust_happy_rat_mend = /** @type {(inputs: Rust_Happy_Rat_MendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In Bearbeitung`)
};

/**
* | output |
* | --- |
* | "In progress" |
*
* @param {Rust_Happy_Rat_MendInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const rust_happy_rat_mend = /** @type {((inputs?: Rust_Happy_Rat_MendInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rust_Happy_Rat_MendInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_rust_happy_rat_mend(inputs)
	return de_rust_happy_rat_mend(inputs)
});